export const LogoBarcodeError = () => {
  return (
    <svg
      width="323"
      height="323"
      viewBox="0 0 323 323"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.5352 62.5C49.5352 58.75 52.8164 55 57.0352 55C60.7852 55 64.5352 58.75 64.5352 62.5V257.5C64.5352 261.719 60.7852 265 57.0352 265C52.8164 265 49.5352 261.719 49.5352 257.5V62.5ZM79.5352 62.5C79.5352 58.75 82.8164 55 87.0352 55C90.7852 55 94.5352 58.75 94.5352 62.5V257.5C94.5352 261.719 90.7852 265 87.0352 265C82.8164 265 79.5352 261.719 79.5352 257.5V62.5ZM117.035 55C120.785 55 124.535 58.75 124.535 62.5V257.5C124.535 261.719 120.785 265 117.035 265C112.816 265 109.535 261.719 109.535 257.5V62.5C109.535 58.75 112.816 55 117.035 55ZM154.535 62.5C154.535 58.75 157.816 55 162.035 55C165.785 55 169.535 58.75 169.535 62.5V257.5C169.535 261.719 165.785 265 162.035 265C157.816 265 154.535 261.719 154.535 257.5V62.5ZM192.035 55C195.785 55 199.535 58.75 199.535 62.5V257.5C199.535 261.719 195.785 265 192.035 265C187.816 265 184.535 261.719 184.535 257.5V62.5C184.535 58.75 187.816 55 192.035 55ZM229.535 62.5C229.535 58.75 232.816 55 237.035 55C240.785 55 244.535 58.75 244.535 62.5V257.5C244.535 261.719 240.785 265 237.035 265C232.816 265 229.535 261.719 229.535 257.5V62.5ZM282.035 55C285.785 55 289.535 58.75 289.535 62.5V257.5C289.535 261.719 285.785 265 282.035 265C277.816 265 274.535 261.719 274.535 257.5V62.5C274.535 58.75 277.816 55 282.035 55Z"
        fill="#FF6363"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M299.553 299.553C301.506 297.601 301.506 294.435 299.553 292.482L29.6066 22.5355C27.654 20.5829 24.4882 20.5829 22.5355 22.5355C20.5829 24.4881 20.5829 27.654 22.5355 29.6066L292.482 299.553C294.435 301.506 297.601 301.506 299.553 299.553Z"
        fill="#FF6363"
      />
      <path
        d="M306.978 285.058C313.031 291.111 313.031 300.925 306.978 306.978C300.925 313.031 291.111 313.031 285.058 306.978L15.1109 37.0312C9.0578 30.9781 9.05778 21.164 15.1109 15.1109C21.164 9.05776 30.9781 9.05776 37.0312 15.1109L306.978 285.058Z"
        stroke="#3B0908"
        strokeOpacity="0.95"
        strokeWidth="21"
      />
    </svg>
  );
};
